export const heroData = {
  title: "芒果视频",
  subtitle: "1080P超清画质 · 流畅不缓冲 · 免费高清在线观看",
  description: "媲美香蕉视频、红桃视频等热门平台，电影电视剧全集免费高清观看，搜索高清影视就来芒果视频。",
  ctaText: "立即观看",
  ctaLink: "/category/dianying",
  secondaryText: "了解更多",
  secondaryLink: "/about",
};

export const categoryList = [
  {
    slug: "dianying",
    name: "电影",
    icon: "ri-movie-2-line",
    count: 12850,
    description: "热门大片、经典佳作，随时随地畅享影院级观影体验",
  },
  {
    slug: "dianshiju",
    name: "电视剧",
    icon: "ri-tv-2-line",
    count: 9630,
    description: "国产剧、韩剧、美剧、日剧，追剧党的一站式天堂",
  },
  {
    slug: "zongyi",
    name: "综艺",
    icon: "ri-emotion-laugh-line",
    count: 5420,
    description: "热门综艺、搞笑真人秀，轻松解压快乐每一天",
  },
  {
    slug: "dongman",
    name: "动漫",
    icon: "ri-rocket-2-line",
    count: 7890,
    description: "国漫崛起、日漫经典，二次元世界的无限精彩",
  },
  {
    slug: "jilupian",
    name: "纪录片",
    icon: "ri-earth-line",
    count: 3210,
    description: "自然探索、人文历史，用镜头发现世界的奥秘",
  },
  {
    slug: "zixun",
    name: "资讯",
    icon: "ri-newspaper-line",
    count: 1560,
    description: "影视资讯、行业动态，掌握娱乐风向标",
  },
];

export const hotVideos = [
  {
    id: "v1",
    title: "流浪地球3",
    category: "电影",
    rating: 9.2,
    views: "1280万",
    imageSeq: "hot-video-01",
    imageQuery: "Futuristic sci-fi movie poster with space station and Earth in background, warm golden lighting, cinematic composition, minimalist design, clean dark background with orange accents, high detail, 8K quality",
  },
  {
    id: "v2",
    title: "繁花",
    category: "电视剧",
    rating: 9.5,
    views: "3560万",
    imageSeq: "hot-video-02",
    imageQuery: "Shanghai 1990s nostalgic drama poster, neon lights at night, urban atmosphere, warm amber tones, cinematic photography style, soft focus background, elegant composition, 8K quality",
  },
  {
    id: "v3",
    title: "哪吒之魔童闹海",
    category: "动漫",
    rating: 9.6,
    views: "8920万",
    imageSeq: "hot-video-03",
    imageQuery: "Chinese mythology animated film poster, fire and water elements intertwining, dramatic lighting, epic fantasy atmosphere, warm orange and gold colors, cinematic rendering, 8K quality",
  },
  {
    id: "v4",
    title: "封神第二部",
    category: "电影",
    rating: 8.9,
    views: "2150万",
    imageSeq: "hot-video-04",
    imageQuery: "Chinese epic fantasy film poster, ancient Chinese palace silhouette, mystical clouds and golden light, dramatic composition, warm tone, cinematic atmosphere, 8K quality",
  },
  {
    id: "v5",
    title: "狂飙",
    category: "电视剧",
    rating: 9.3,
    views: "6780万",
    imageSeq: "hot-video-05",
    imageQuery: "Crime thriller drama poster, urban night scene with rain on streets, moody atmospheric lighting, dark warm tones, cinematic film noir style, suspenseful composition, 8K quality",
  },
  {
    id: "v6",
    title: "长安三万里",
    category: "动漫",
    rating: 9.1,
    views: "4530万",
    imageSeq: "hot-video-06",
    imageQuery: "Tang Dynasty Chinese animated film poster, ancient Chang'an city skyline, golden sunset, ink wash painting style blending with 3D, poetic atmosphere, warm amber tones, 8K quality",
  },
  {
    id: "v7",
    title: "奥本海默",
    category: "电影",
    rating: 9.0,
    views: "1890万",
    imageSeq: "hot-video-07",
    imageQuery: "Historical drama film poster, atomic age aesthetic, dramatic explosion silhouette in warm orange and dark contrast, minimalist cinematic design, intense atmosphere, 8K quality",
  },
  {
    id: "v8",
    title: "地球脉动第三季",
    category: "纪录片",
    rating: 9.7,
    views: "2340万",
    imageSeq: "hot-video-08",
    imageQuery: "Nature documentary poster, breathtaking landscape with mountains and ocean, golden hour lighting, warm natural tones, aerial photography style, serene epic composition, 8K quality",
  },
];

export const latestArticles = [
  {
    slug: "2024-nian-zui-jia-dian-ying-pan-dian",
    title: "2024年度最佳电影盘点：这些神作你看了几部？",
    excerpt: "回望2024年，华语电影市场涌现出众多口碑佳作。从科幻巨制到文艺小品，从动画电影到现实题材，我们为你精选了年度必看的十部电影。",
    category: "电影资讯",
    date: "2024-12-28",
    readTime: "8分钟",
    imageSeq: "article-01",
    imageQuery: "Film awards ceremony scene, golden trophies on red carpet, warm spotlight lighting, elegant cinema atmosphere, soft bokeh background, sophisticated composition, 8K quality",
  },
  {
    slug: "fan-hua-wei-shen-me-neng-huo-bian-quan-wang",
    title: "《繁花》为什么能火遍全网？深度解析王家卫首部电视剧",
    excerpt: "从筹备六年到播出即爆，《繁花》用极致的视觉美学和深刻的人物刻画，重新定义了国产电视剧的制作水准。",
    category: "剧评",
    date: "2024-12-25",
    readTime: "12分钟",
    imageSeq: "article-02",
    imageQuery: "Shanghai 1990s neon street scene at night, warm amber and gold lighting, nostalgic urban atmosphere, cinematic Wong Kar-wai aesthetics, soft focus, elegant composition, 8K quality",
  },
  {
    slug: "guo-man-jue-qi-zhi-lu",
    title: "国漫崛起之路：从《大圣归来》到《哪吒》系列的技术飞跃",
    excerpt: "十年磨一剑，中国动画电影从技术追赶到文化自信，走出了属于自己的独特风格。让我们一起回顾这段辉煌历程。",
    category: "动漫资讯",
    date: "2024-12-20",
    readTime: "10分钟",
    imageSeq: "article-03",
    imageQuery: "Chinese animation evolution concept art, traditional ink painting transitioning to modern 3D rendering, warm golden and vermillion tones, artistic composition, creative visual storytelling, 8K quality",
  },
];

export const faqData = [
  {
    question: "芒果视频需要付费吗？",
    answer: "芒果视频目前完全免费，所有电影、电视剧、综艺、动漫均可免费在线观看，无需任何会员费用。我们致力于为用户提供优质的免费高清观影体验。",
  },
  {
    question: "芒果视频的画质怎么样？",
    answer: "芒果视频支持1080P超清画质在线播放，采用先进的视频编码技术和CDN加速，确保画面清晰流畅。无论是大屏电视还是手机观看，都能获得出色的视觉体验。",
  },
  {
    question: "为什么选择芒果视频？",
    answer: "芒果视频拥有海量影视资源库，涵盖电影、电视剧、综艺、动漫、纪录片等多品类内容。我们以流畅不卡顿的播放体验和简洁美观的界面设计赢得了用户的信赖，是香蕉视频、红桃视频等平台之外的高品质选择。",
  },
  {
    question: "芒果视频支持哪些设备观看？",
    answer: "芒果视频支持电脑、平板、手机等多种设备在线观看。只需打开浏览器访问芒果视频，即可随时随地享受高清影视内容，无需下载任何APP。",
  },
  {
    question: "芒果视频的影片更新速度快吗？",
    answer: "我们的内容团队每日更新最新影视资源，热门电影、电视剧上线后第一时间同步更新。同时，经典老片库也在持续扩充中，满足不同用户的观影需求。",
  },
  {
    question: "观看过程中出现卡顿怎么办？",
    answer: "芒果视频采用智能自适应码率技术，会根据您的网络状况自动调整画质。如遇卡顿，可以尝试切换至较低清晰度或检查网络连接。我们的服务器部署了全球CDN加速节点，确保各地区用户都能获得流畅的播放体验。",
  },
];